import { render, staticRenderFns } from "./ProductSwitch.vue?vue&type=template&id=bbfd82a0&"
import script from "./ProductSwitch.vue?vue&type=script&lang=js&"
export * from "./ProductSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports